// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoContainerWrapper_sVY0A {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
}

.infoContainer_ujIPi {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_LPtyU {
  &.active_ycKtu {
    display: block;
    border: 1px solid #e5e5e5;
    padding: 6px 10px;
    border-radius: 15px;
  }
  &.disabled_Y5nDT {
    display: none;
  }
}



.header_sE6LE {
  display: flex;
  justify-content: space-between;
}

.headerMail_qaVp4 {
  display: flex;
  align-items: center;
  justify-content: start;
  max-width: 200px;
  margin-top: 10px;
}

.iconContainer_SYqpc {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--d9-background);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 27px;
  width: 30px;

}

.addConnection_yL02J {
  color: #159b7c;
  cursor: pointer;
}

.phoneNumbersList_SSYTr {
  display: flex;
  flex-direction: column;
  gap: 17px;
  margin: 10px 10px;
}

.phoneNumberItem_tcl5H {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666666;
}

.qrContainer_SUQL2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.loader_WFf9o {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate_JvCBe 1s linear infinite;
}
.loader_WFf9o::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid var(--_10a37f-background);
  animation: prixClipFix_Kd6Vj 2s linear infinite;
}

@keyframes rotate_JvCBe {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix_Kd6Vj {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}



.iconContainer2_hNnFq {
  border: 1px solid var(--f4-background);
  height: 45px;
  min-width: 45px;
  border-radius: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.newConnectionButton_GzJTe {
  border-radius: 999px;
  height: 45px;
  border: 1px solid #00000026;
  background-color: transparent;
  padding: 0px 14px;
  font-family: Inter;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/TelamatelFormAutomate/EmailConfiguration/EmailConfiguration.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;;;;AAIA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAAoC;AACtC;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,+CAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,gEAAgE;EAClE;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,mEAAmE;EACrE;EACA;IACE,gEAAgE;EAClE;AACF;;;;AAIA;EACE,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n    border: 1px solid #e5e5e5;\n    padding: 6px 10px;\n    border-radius: 15px;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.headerMail {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  max-width: 200px;\n  margin-top: 10px;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--d9-background);\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  height: 27px;\n  width: 30px;\n\n}\n\n.addConnection {\n  color: #159b7c;\n  cursor: pointer;\n}\n\n.phoneNumbersList {\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n  margin: 10px 10px;\n}\n\n.phoneNumberItem {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #666666;\n}\n\n.qrContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite;\n}\n.loader::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid var(--_10a37f-background);\n  animation: prixClipFix 2s linear infinite;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n  }\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);\n  }\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n  }\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n  }\n}\n\n\n\n.iconContainer2 {\n  border: 1px solid var(--f4-background);\n  height: 45px;\n  min-width: 45px;\n  border-radius: 50px;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.newConnectionButton {\n  border-radius: 999px;\n  height: 45px;\n  border: 1px solid #00000026;\n  background-color: transparent;\n  padding: 0px 14px;\n  font-family: Inter;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainerWrapper": `infoContainerWrapper_sVY0A`,
	"infoContainer": `infoContainer_ujIPi`,
	"contentContainer": `contentContainer_LPtyU`,
	"active": `active_ycKtu`,
	"disabled": `disabled_Y5nDT`,
	"header": `header_sE6LE`,
	"headerMail": `headerMail_qaVp4`,
	"iconContainer": `iconContainer_SYqpc`,
	"addConnection": `addConnection_yL02J`,
	"phoneNumbersList": `phoneNumbersList_SSYTr`,
	"phoneNumberItem": `phoneNumberItem_tcl5H`,
	"qrContainer": `qrContainer_SUQL2`,
	"loader": `loader_WFf9o`,
	"rotate": `rotate_JvCBe`,
	"prixClipFix": `prixClipFix_Kd6Vj`,
	"iconContainer2": `iconContainer2_hNnFq`,
	"newConnectionButton": `newConnectionButton_GzJTe`
};
export default ___CSS_LOADER_EXPORT___;
